<template>
    <span class="test-name bg-light-blue  ">
      <span>{{ name }}
        <span></span>
        <template v-if="!disableDelete">
          <font-awesome-icon class="delete text-warning" title="Delete" icon="trash" v-on:click="deleteTest()" />
        </template>
      </span>
    </span>
</template>

<script>
import {EventBus} from '@/global-event-bus.js'
import {
  EVENT_PATIENT_DELETE_TEST
} from '@/event-constants.js'

export default{
  name: 'TestSnippet',
  props: {
    name: String,
    id: Number,
    disableDelete: Boolean
  },

  methods: {
    deleteTest() {
      EventBus.$emit(EVENT_PATIENT_DELETE_TEST, this.id);
    }
  }
}
</script>

<style scoped>
  .test-name {
    margin-left: 10px;
    /* padding: 5px; */
    margin-bottom: 5px;
    padding-left: 10px;
    padding-right: 10px;
    display: inline-block;
  }

  .delete {
    margin-left: 20px;
  }
</style>
